import {Input} from 'react-bootstrap'
import React from 'react'
import StaticTextComponent from './StaticTextComponent'
import BaseInputComponent from './BaseInputComponent'
import {t} from '../../helpers/translate.js'

class RadioComponent extends BaseInputComponent {

  render() {
    let value = this.getValue();
    if (this.props.isStatic) {
      let text = '';
      for (let option of this.props.options) {
        if(value !== undefined && (option.value === value || option.value === value.toLowerCase())) {
          text = t(option.text)
        }
      }
      return <StaticTextComponent id={this.props.id} value={text}/>
    }
    return <div className={`form-group ${this.state.isInvalid ? t('has-error') : ''}`}>
      {this.props.options.map((item, i) =>
        <div key={i} className="radio-inline"><label htmlFor={value}><input
          id={this.props.id}
          type="radio"
          name={this.props.keyPath.join('.')}
          onChange={(event) => {this.handleChange(item.value)}}
          checked={value !== undefined && (item.value == value || item.value == value.toLowerCase())}
        />{t(item.text)}</label></div>
      )
      }
    </div>
  }
}

RadioComponent.displayName = 'RadioComponent';
export default RadioComponent;



// WEBPACK FOOTER //
// ./src/components/common/RadioComponent.js